import React from 'react';
import { Link } from 'react-router-dom';
import logoHeaderDark from '../../assets/brand/logo-header-dark.svg';
import iconDark from '../../assets/brand/icon-dark.svg';

export function Nav() {
  const scrollTo = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    // The 32px side padding costs 64px of a 375px screen, which is most of what
    // the Sign in button needs. Halved below sm; unchanged from sm up.
    <nav
      className="sticky top-0 z-50 backdrop-blur-md py-4 px-4 sm:px-8"
      style={{
        backgroundColor: 'rgba(12,14,18,0.85)',
        borderBottom: '0.5px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        {/* The landing page is always dark, so the on-dark logo. The full
            lockup (28px tall, about 159px wide) fits beside Sign in and Get
            started from 370px up; on narrower phones only the icon. */}
        <Link to="/" className="flex items-center flex-shrink-0">
          <img
            src={iconDark}
            alt="MyCryptoPlanner"
            width={36}
            height={36}
            className="block min-[370px]:hidden w-9 h-9"
          />
          <img
            src={logoHeaderDark}
            alt="MyCryptoPlanner"
            width={170}
            height={30}
            className="hidden min-[370px]:block h-7 sm:h-[30px] w-auto"
          />
        </Link>

        <div className="flex items-center gap-2 sm:gap-6">
          <a
            href="#features"
            onClick={scrollTo('features')}
            className="hidden sm:block text-[13px] transition-colors hover:opacity-100"
            style={{ color: 'rgba(244,241,234,0.6)' }}
          >
            Features
          </a>
          <a
            href="#pricing"
            onClick={scrollTo('pricing')}
            className="hidden sm:block text-[13px] transition-colors hover:opacity-100"
            style={{ color: 'rgba(244,241,234,0.6)' }}
          >
            Pricing
          </a>
          {/* Ghost secondary, deliberately NOT an outlined button: on desktop this
              has always been a plain text link sitting in the Features / Pricing
              row, and a border would restyle a header that is not the problem.
              Below sm it gains padding and a 44px floor so it is a real tap
              target, which is invisible on desktop where the padding is zero. */}
          <Link
            to="/login"
            className="inline-flex items-center text-[13px] transition-colors max-sm:px-3 max-sm:min-h-[44px]"
            style={{ color: 'rgba(244,241,234,0.6)' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#f4f1ea')}
            onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(244,241,234,0.6)')}
          >
            Sign in
          </Link>
          <a
            href="#pricing"
            onClick={scrollTo('pricing')}
            className="inline-flex items-center text-[13px] font-medium px-4 max-sm:px-3 py-2 max-sm:min-h-[44px] rounded-lg transition-transform hover:scale-[1.02] whitespace-nowrap"
            style={{ backgroundColor: '#f4f1ea', color: '#0c0e12' }}
          >
            Get started
          </a>
        </div>
      </div>
    </nav>
  );
}
